<script setup lang="ts">
// Outline bed. Colour follows CSS `color`.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <path
      d="M1.16667 11.6667V7C1.16667 6.69058 1.28958 6.39383 1.50838 6.17504C1.72717 5.95625 2.02391 5.83333 2.33333 5.83333H11.6667C11.9761 5.83333 12.2728 5.95625 12.4916 6.17504C12.7104 6.39383 12.8333 6.69058 12.8333 7V11.6667"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
    <path
      d="M2.33333 5.83333V3.5C2.33333 3.19058 2.45625 2.89383 2.67504 2.67504C2.89383 2.45625 3.19058 2.33333 3.5 2.33333H10.5C10.8094 2.33333 11.1062 2.45625 11.325 2.67504C11.5437 2.89383 11.6667 3.19058 11.6667 3.5V5.83333"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
    <path
      d="M7 2.33333V5.83333"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
    <path
      d="M1.16667 10.5H12.8333"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke="currentColor"
    />
  </svg>
</template>
